import type { EmployeeTaskSummary, TaskType } from '@pms/shared';
import { ALL_TYPES } from './taskConstants';
import { TaskTypeCountChip } from './TaskBadges';
import { fullName, initials } from './taskConstants';

export function EmployeeCard({ emp, onClick }: { emp: EmployeeTaskSummary; onClick: () => void }) {
  const breakdown = ALL_TYPES.filter((t) => (emp.type_breakdown[t] ?? 0) > 0) as TaskType[];
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center gap-2 rounded-xl border border-border/60 bg-card p-5 text-center shadow-card transition-all hover:border-primary/40 hover:shadow-md"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-muted text-sm font-bold text-foreground">
        {initials(emp.first_name, emp.last_name)}
      </span>
      <div>
        <p className="font-semibold text-foreground">{fullName(emp.first_name, emp.last_name)}</p>
        {emp.employee_code && <p className="text-xs text-muted-foreground">{emp.employee_code}</p>}
      </div>
      <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
        {emp.task_count} task{emp.task_count === 1 ? '' : 's'}
      </span>
      {breakdown.length > 0 && (
        <div className="flex flex-wrap justify-center gap-1">
          {breakdown.map((t) => <TaskTypeCountChip key={t} type={t} count={emp.type_breakdown[t]!} />)}
        </div>
      )}
    </button>
  );
}
